import { configureStore } from "@reduxjs/toolkit";
import { campaignReducer } from "./campaignSlice";
import { authApi, campaignApi,quizApi,questionApi ,progressApi} from "../../Apis";
import { userAuthReducer } from "./userAuthSlice";
import { quizReducer } from "./quizSlice";
import { questionReducer } from "./questionSlice";
import { progressReducer, progressSlice } from "./progressSlice";

const store = configureStore({
  reducer: {
    campaignStore: campaignReducer,
    userAuthStore: userAuthReducer,
    useQuizStore: quizReducer,
    useQuestionStore: questionReducer,
    useProgressStore: progressReducer,
    
    
    [campaignApi.reducerPath]: campaignApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [quizApi.reducerPath]:quizApi.reducer,
    [questionApi.reducerPath]:questionApi.reducer,
    [progressApi.reducerPath]:progressApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(campaignApi.middleware)
      .concat(quizApi.middleware)
      .concat(questionApi.middleware)
      .concat(progressApi.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export default store;   